import React, { useCallback, useMemo, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { CloudUpload } from 'react-bootstrap-icons';
import cn from 'classnames';

import { UiIcon } from '@components/common/icons/ui-icon';

import styles from './publish.module.scss';

type PublishMessageProps = {
  noteDetail: {
    noteAlias?: string;
    username?: string;
  };
};

type PublishFooterProps = {
  publishArticle: Function;
};

export const PublishMessage = ({ noteDetail }: PublishMessageProps) => {
  const message = useMemo(
    () => `${noteDetail.noteAlias}`.toLowerCase(),
    [noteDetail.noteAlias]
  );

  return (
    <div className='d-flex flex-column align-items-center'>
      <UiIcon size="35" icon={CloudUpload} />
      <div className='my-2 user-select-none'>{message}</div>
      <strong className='my-2 h2 text-center'>
        This action will publish your article to the website
      </strong>
    </div>
  );
};

export const PublishFooter = ({
  publishArticle
}: PublishFooterProps) => {
  const [value, setValue] = useState('');
  const [isValid, setIsValid] = useState(false);
  const validateMessage = 'confirm'

  const handleInput = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const input = e.target.value;
      if (input.length >= validateMessage.length + 1) {
        return;
      }
      setIsValid(validateMessage === input);
      setValue(input);
    },
    [validateMessage, setIsValid, setValue]
  );
  return (
    <div className='w-100 justify-content-center d-flex px-4'>
      <div className='w-100'>
        <Form.Text className={styles.confirmation_text}>
          To proceed, please enter{' '}
          <strong className='text-info'>"{validateMessage}"</strong> in the box
          below
        </Form.Text>
        <Form.Control
          type='text'
          required
          isInvalid={!isValid}
          value={value}
          onChange={handleInput}
          autoFocus
        />
        <Button
          className='mt-2 w-100'
          variant={!isValid ? 'outline-danger' : 'outline-primary'}
          disabled={!isValid}
          onClick={() => publishArticle()}>
          Publish Article
        </Button>
      </div>
    </div>
  );
};
